import { render, staticRenderFns } from "./UnidadesCentroDeCusto.vue?vue&type=template&id=04056c30&scoped=true&"
import script from "./UnidadesCentroDeCusto.vue?vue&type=script&lang=js&"
export * from "./UnidadesCentroDeCusto.vue?vue&type=script&lang=js&"
import style0 from "./UnidadesCentroDeCusto.vue?vue&type=style&index=0&id=04056c30&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04056c30",
  null
  
)

export default component.exports